"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShadowConfig = void 0;
var React = require("react");
var merge_styles_1 = require("@fluentui/merge-styles");
/**
 * Get a shadow config.
 * @param stylesheetKey - Globally unique key
 * @param win - Reference to the `window` global.
 * @returns ShadowConfig
 */
var useShadowConfig = function (stylesheetKey, inShadow, win) {
    if (inShadow === void 0) { inShadow = false; }
    return React.useMemo(function () {
        return (0, merge_styles_1.makeShadowConfig)(stylesheetKey, inShadow, win);
    }, [stylesheetKey, inShadow, win]);
};
exports.useShadowConfig = useShadowConfig;
//# sourceMappingURL=useShadowConfig.js.map